import { render } from "./ProviderHome.vue?vue&type=template&id=36c3454a&scoped=true"
import script from "./ProviderHome.vue?vue&type=script&lang=js"
export * from "./ProviderHome.vue?vue&type=script&lang=js"

import "./ProviderHome.vue?vue&type=style&index=0&id=36c3454a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c3454a"]])

export default __exports__